<template>
    <div class="navbar">
        <div class="left-title">
            <img class="logo" src="../../../assets/ZoomLogo.png">
        </div>
        <div class="right-menu">
           <zm-dropdown v-if="schedule.length" style="margin-right: 20px">
                <span class="zm-dropdown-link">
                    Today's on call: {{ schedule[0].name + '(' + schedule[0].mail + ',' + schedule[0].mobile + ')' }}
                   <i class="zm-icon-down zm-icon--right"></i>
                </span>
                <zm-dropdown-menu slot="dropdown" :hide-timeout="350">
                    <zm-dropdown-item v-for="item in schedule" :key="item.date">
                    {{ item.date + ':' + item.name + '(' + item.mail + ',' + item.mobile + ')' }}
                    </zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
           <zm-dropdown @command="handleCommand" trigger="click">
                <span class="zm-dropdown-link">
                    Hi, {{ username }}
                   <i class="zm-icon-down zm-icon--right"></i>
                </span>
                <zm-dropdown-menu slot="dropdown" :hide-timeout="350">
                    <zm-dropdown-item command="logout">Log Out
                    </zm-dropdown-item>
                    <zm-dropdown-item command="exportTooltip" v-if="isAdmin">Export Tooltip
                    </zm-dropdown-item>
                    <zm-dropdown-item command="importTooltip" v-if="isAdmin">Import Tooltip
                    </zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
        </div>
        <zm-dialog :title="title" :visible.sync="visible" append-to-body>
            <zm-form>
                <zm-form-item>
                    <zm-input type="textarea" v-model="tipData"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="importTooltip()">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listSchedule } from '@/api/guide'
import {
    listTooltip,
    batchCreateTooltip
} from '@/api/tip'
export default {
    data () {
        return {
            isAdmin: localStorage.role === 'SUPER_ADMIN',
            visible: false,
            title: '',
            tipData: '',
            schedule: [],
            username: localStorage.username
        }
    },
    created () {
        this.listSchedule()
    },
    methods: {
        listSchedule () {
            listSchedule().then(response => {
                this.schedule = response
            })
        },
        handleCommand (command) {
            if (command === 'logout') {
                this.logout()
            } else if (command === 'exportTooltip') {
                this.exportTooltip()
            } else if (command === 'importTooltip') {
                this.showImport()
            }
        },
        logout () {
            localStorage.setItem('token', '')
            location.reload()
        },
        showImport () {
            this.title = 'Import Tooltip'
            this.visible = true
            this.tipData = ''
        },
        importTooltip () {
            batchCreateTooltip(this.tipData).then(response => {
                this.visible = false
                this.$message.success('Import success')
            })
        },
        exportTooltip () {
            listTooltip().then(response => {
                this.title = 'Export Tooltip'
                this.visible = true
                this.tipData = JSON.stringify(response)
            })
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  width: 100%;
//   margin-left: 170px;
  position: fixed;
  background-color: #fff;
  z-index: 99;
//   top: 0;
//   left: 0px;
//   right: 0;
//   line-height: 80px;
  border-radius: 0px !important;
  border-bottom: 1px solid #d8dce5;
  .left-title{
    float: left;
    height: 100%;
    line-height: 10px;
    // padding: 0 30px;
  }
  .right-menu {
    float: right;
    height: 100%;
    margin-right: 10px;
    line-height: 80px;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
  }
}
.logo {
    height: 27px;
    padding-top: 20px;
    padding-left: 20px;
}
</style>
